export default "__VITE_ASSET__4zvSgGbp__"